import React, {Component} from 'react';

import {connect} from 'react-redux';
 import {bindActionCreators} from 'redux';

import config from  '../../config';
import {   displayMessage   }  from 'actions';

class APIDocumentation extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            accessNotAllowed: false
        };
    };

    componentWillMount() {
         this._displayAccessNotAllowedMessage = _.debounce(this._displayAccessNotAllowedMessage, 1000);
        this.checkPermissions(this.props);
    }

    checkPermissions(properties) {
        var accessNotAllowed = false;
        if (!properties.user.token) {
            accessNotAllowed = {'messageCode': 'errorAccessAdministrator', 'redirect': '/login'}
        } else if (_.size(_.intersection(properties.user.user.Roles, ['Administrator'])) == 0) {
            accessNotAllowed = {'messageCode': 'errorAccessAdministrator', 'redirect': '/'}
        }

        if (accessNotAllowed) {
            setTimeout(function () {
                this._displayAccessNotAllowedMessage(accessNotAllowed.messageCode);

            }.bind(this), 1000);
            this.setState({'accessNotAllowed': true}, function () {
                this.context.router.push(accessNotAllowed.redirect);
            });

        }
    }

    _displayAccessNotAllowedMessage(message) {
        return this.props.displayMessage({
            'messageType': 'warning',
            'messageCode': message
        });
    }


    componentWillReceiveProps(nextProps) {

        if (this.props.user.token && !nextProps.user.token) { /* after log out */
            return this.setState({'accessNotAllowed': true}, function () {
                return this.context.router.push('/login');
            });
        }
        this.checkPermissions(nextProps)

    }

    render() {
        if (this.state.accessNotAllowed) {
            return null;
        }

         return (
             <iframe style={{'width':'100%', 'height':'100%'}} src={config.getEnvironment().serverBaseURL+'/API_documentation?x-access-token='+this.props.user.token}
             />
         );

    }
}
function mapStateToProps(state, ownProps) {
    return {
        userReducer: state.userReducer,
        currentURL: ownProps.location
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(APIDocumentation);
